import styled from 'styled-components';
import { Box } from '@components/Box';
import { themeSpace } from '@utils/styledTheme.util';

export const Lottie = styled(Box)`
  width: 100%;
`;

export const PartyLottie = styled(Box)`
  width: 160%;
  position: relative;
  left: -60%;
  margin: 0 auto;
  margin-top: ${themeSpace(9)};
  margin-bottom: ${themeSpace(9)};
`;
